// extracted by mini-css-extract-plugin
export default {"tabs":"sPQFhLXpHq"};
    if(module.hot) {
      // 1648553825575
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  